import { newsBase } from './ipConfig'

//  添加志愿者申请
export const saveVolunTeerUrl = newsBase + '/museum_hn/api/volunteer/apply/save.html';
//  志愿者活动列表
export const volunteerActivityListUrl = newsBase + '/museum_hn/api/volunteer/activity/list.html';
//  申请志愿者活动
export const commitVolunteerActivityUrl = newsBase + '/museum_hn/api/volunteer/activity/entry.html';
//  查看讲解员
export const narratorListUrl = newsBase +'/museum_hn/api/ag/agguide/list.html';

//  检查当前是否可预约
export const checkCanOrderUrl = newsBase +'/museum_hn/api/ag/agorder/checkCanOrder.dhtml';
//  获取预约配置信息
export const getRuleInfoUrl = newsBase +'/museum_hn/api/ag/agorder/getRuleInfo.dhtml';
//  获取代码表List
export const getDictionaryListUrl = newsBase +'/museum_hn/api/common/getDictionaryList.html';
//  提交讲解预约
export const saveaGorderUrl = newsBase +'/museum_hn/api/ag/agorder/save.dhtml';
//  我的预约列表
export const myVolunteerActivityListUrl = newsBase +'/museum_hn/api/ag/agorder/list.dhtml';
//  取消预约的志愿者活动
export const cancelVolunteerActivityUrl = newsBase +'/museum_hn/api/ag/agorder/cancel.dhtml';


//个人中心 用户，志愿者积分
export const getSumScoreByOpenid = `${newsBase}/museum_hn/api/guestUser/getSumScoreByOpenid.html`

export const getDetailScoreByOpenid = `${newsBase}/museum_hn/api/guestUser/getDetailScoreByOpenid.html`

//志愿者活动列表
export const entryList = `${newsBase}/museum_hn/api/volunteer/activity/entryList.html`

//取消活动
export const cancelEntry = `${newsBase}/museum_hn/api/volunteer/activity/cancelEntry.html`

//删除活动记录
export const delEntry = `${newsBase}/museum_hn/api/volunteer/activity/delEntry.html`

//志愿者活动详情
export const entryDetail = `${newsBase}/museum_hn/api/volunteer/activity/entryDetails.html`


//取消志愿者申请 
export const delApply = `${newsBase}/museum_hn/api/volunteer/apply/delApply.html`

//获取志愿者进度
export const getProgressByOpenid = `${newsBase}/museum_hn/api/volunteer/apply/getProgressByOpenid.html`

